import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';

const ApiResponseDialog = ({ open, response, onClose }) => {
  const parseValidationErrors = (errorString) => {
    const lines = errorString.split('\n');
    const errors = [];

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      if (
        line &&
        !line.startsWith(' ') &&
        !line.includes('validation error') &&
        !line.includes('For further information')
      ) {
        const fieldName = line;

        if (i + 1 < lines.length) {
          const errorLine = lines[i + 1].trim();
          if (errorLine.startsWith('Value error,')) {
            const errorMessage = errorLine.replace('Value error, ', '').split(' [type=')[0];
            errors.push({
              field: fieldName,
              message: errorMessage,
            });
          }
        }
      }
    }

    return errors;
  };

  const renderErrorContent = () => {
    if (!response) {
      return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <p className="text-gray-700">No hay respuesta del servidor.</p>
        </div>
      );
    }

    if (typeof response === 'object' && response.error_type === 'ValidationError') {
      const validationErrors = parseValidationErrors(response.error);

      return (
        <div className="space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <h4 className="text-red-800 font-semibold mb-2">
              {response.message || 'Error de validación'}
            </h4>

            {validationErrors.length > 0 ? (
              <ul className="list-disc list-inside space-y-1 text-red-700">
                {validationErrors.map((error, index) => (
                  <li key={index}>
                    <strong>{error.field}:</strong> {error.message}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-red-700 text-sm font-mono whitespace-pre-wrap">{response.error}</p>
            )}
          </div>
        </div>
      );
    }

    if (typeof response === 'object' && response.error_type) {
      return (
        <div className="space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <h4 className="text-red-800 font-semibold mb-2">
              {response.message || `Error: ${response.error_type}`}
            </h4>
            <p className="text-red-700 text-sm whitespace-pre-wrap">
              {response.error || 'Ha ocurrido un error inesperado'}
            </p>
          </div>
        </div>
      );
    }

    if (typeof response === 'string') {
      return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <h4 className="text-red-800 font-semibold mb-2">Error</h4>
          <p className="text-red-700">{response}</p>
        </div>
      );
    }

    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <pre className="text-sm text-gray-700 whitespace-pre-wrap overflow-auto">
          {JSON.stringify(response, null, 2)}
        </pre>
      </div>
    );
  };

  const getDialogTitle = () => {
    if (!response) {
      return 'Sin respuesta';
    }
    if (typeof response === 'object' && response && response.error_type) {
      return 'Error en la operación';
    }
    if (typeof response === 'string' && response.toLowerCase().includes('error')) {
      return 'Error en la operación';
    }
    return 'Resultado de la operación';
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>{getDialogTitle()}</DialogTitle>
      <DialogBody>{renderErrorContent()}</DialogBody>
      <DialogActions handleClose={onClose} handleSave={null} />
    </DialogContainer>
  );
};

export default ApiResponseDialog;
